/* CC PDP, 2026-09-25 rewrite for the mock-up imagery hand-off.

   Format swatches and Size buttons replace the two <select>s. Format swaps
   the picture (each Format has one variant image, shared by its four
   sizes); Size changes the price and deliberately leaves the picture alone.
   The gallery is a stack of images cross-faded on opacity, because a hard
   src swap flashes. Prices come from the server-rendered money strings, so
   the page can never disagree with Liquid's own formatting. */
(() => {
  const root = document.querySelector('[data-cc-pdp]');
  if (!root) return;

  let variants = [];
  try { variants = JSON.parse(document.getElementById('cc-pdp-variants').textContent); } catch (_) { return; }
  let prices = {};
  try { prices = JSON.parse(root.querySelector('[data-cc-variant-prices]').textContent); } catch (_) { /* fallback below */ }
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;
  const priceOf = (v) => prices[v.id] || money(v.price);

  const groups = Array.from(root.querySelectorAll('[data-cc-group]'));
  const idEl = root.querySelector('[data-cc-variant-id]');
  const atc = root.querySelector('[data-cc-atc]');
  const form = root.querySelector('[data-cc-pdp-form]');
  const priceEl = root.querySelector('[data-cc-price]');
  const priceNote = root.querySelector('[data-cc-price-note]');

  const groupByName = (name) => groups.find((g) => g.dataset.ccGroupName === name);
  const checked = (g) => g && g.querySelector('[aria-checked="true"]');
  const selection = () => {
    const values = [];
    groups.forEach((g) => { const b = checked(g); values[Number(g.dataset.ccGroup)] = b ? b.dataset.ccValue : null; });
    return values;
  };
  const optsOf = (v) => [v.option1, v.option2, v.option3].filter((x) => x !== null && x !== undefined);
  const findVariant = (values) => variants.find((v) => optsOf(v).every((val, i) => val === values[i]));

  /* ---- artwork overview (2026-09-30) ----
     The spec panel under the buy box follows the selection, so it can never
     disagree with the price above it. Sizes come from a map the section emits
     once; the frame line is read from the chosen Format. Wording is locked in
     CLAUDE.md: no white border (we are No mount) and no wood species. */
  const ovEl = document.querySelector('[data-cc-overview]');
  let ovMap = null;
  if (ovEl) { try { ovMap = JSON.parse(ovEl.dataset.map); } catch (_) { ovMap = null; } }
  /* 2026-10-07: the overview carries a preview of the selection beside the
     facts. One plain-ground shot per Format, emitted as a map by the section.
     Parsed separately from ovMap so a malformed one cannot take out the
     other, and the panel keeps working with no image at all. */
  let ovImgs = null;
  if (ovEl) { try { ovImgs = JSON.parse(ovEl.dataset.imgs || 'null'); } catch (_) { ovImgs = null; } }
  const ovImgEl = ovEl ? ovEl.querySelector('[data-ov-img]') : null;
  const FRAME_LINE = {
    'Framed black': 'Black wood box frame',
    'Framed white': 'White wood box frame',
    'Framed natural': 'Natural wood box frame',
    Unframed: 'Unframed print, no frame',
  };
  const updateOverview = (v) => {
    if (!ovEl || !ovMap) return;
    const opts = optsOf(v);
    const size = opts.find((o) => ovMap[o]);
    const fmt = opts.find((o) => FRAME_LINE[o]);
    const set = (k, txt) => { const el = ovEl.querySelector('[data-ov="' + k + '"]'); if (el) el.textContent = txt; };
    if (size) { set('print', ovMap[size].print || '—'); }
    /* an unframed print has no framed size and no glazing - say so rather
       than print a dimension the buyer will not receive */
    const framed = fmt && fmt !== 'Unframed';
    if (size) set('framed', framed ? (ovMap[size].framed || '—') : 'Not framed');
    set('frame', fmt ? FRAME_LINE[fmt] : '—');
    set('glaze', framed ? 'Acrylic, no mount' : 'None');

    /* the preview follows the Format. Size never changes it: one image per
       frame colour serves every size, which is the same rule the gallery
       follows. */
    if (ovImgEl && ovImgs && fmt && ovImgs[fmt]) {
      const next = ovImgs[fmt];
      if (ovImgEl.getAttribute('src') !== next) {
        ovImgEl.setAttribute('src', next);
        ovImgEl.setAttribute('alt', '');
      }
    }

    /* 2026-10-03: tell Blankwall how big the print actually is.
       Its AR was showing a print floor to ceiling. The reason is arithmetic:
       it resolves dimensions from the variant title, our Size option reads
       "61x91" with no unit, and the app's default unit is inches. 61 x 2.54
       is 155cm and 91 x 2.54 is 231cm, which is the wall-sized frame in the
       screenshots.
       Its own first source is an element with this id, checked before the
       variant title, so filling it wins outright. The text carries "cm", so
       the default unit never applies. Written here rather than once in
       Liquid because the visitor changes size after the page loads and the
       app reads this at the moment the button is pressed. */
    const bw = document.getElementById('product-meta-dimensions-override');
    if (bw && size && ovMap[size].print) {
      /* the PRINT size, never the framed one: the app draws its own frame
         around whatever it is given, so handing it 64 x 94 would show a
         frame around a frame. The map already carries the unit. */
      let line = String(ovMap[size].print).replace(/\u00d7/g, 'x').replace(/\s+/g, ' ').trim();
      if (!/cm|mm|in\b|"/.test(line)) line += ' cm';
      bw.textContent = line;
    }
  };

  /* ---- gallery ----
     2026-09-25. Every image on the stage carries what it shows: its
     variants (data-cc-variants), format, size, room (data-cc-room), kind
     (variant-or-room | own = pool table | guide | plain) and caption.

     The visible SET follows the visitor's choice: that choice's room
     shots, the pool table (61x91 framed only, in the chosen colour), the
     size guide, and the plain photograph last. Thumbnails, swipe and the
     full-screen viewer all use the set, so a product with 36 mock-ups
     still shows 4-5 thumbnails. A product without mock-ups shows all of
     its photographs, exactly as before. */
  const stage = root.querySelector('[data-cc-stage]');
  const imgs = stage ? Array.from(stage.querySelectorAll('[data-cc-img]')) : [];
  const rail = root.querySelector('[data-cc-rail]');
  const cap = root.querySelector('[data-cc-cap]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let current = Math.max(0, imgs.findIndex((im) => im.classList.contains('is-on')));
  let setIdx = imgs.map((_, i) => i);
  let setKey = '';
  let thumbs = [];
  let lbDirty = true;

  const d = (i, k) => (imgs[i] && imgs[i].dataset[k]) || '';
  const selFormat = () => { const b = checked(groupByName('Format')); return b ? b.dataset.ccValue : ''; };
  const selSize = () => { const b = checked(groupByName('Size')); return b ? b.dataset.ccValue : ''; };

  const computeSet = () => {
    const fmt = selFormat(), size = selSize();
    const all = imgs.map((_, i) => i);
    if (!fmt) return all;
    const mock = (i) => d(i, 'kind') === 'variant-or-room';
    let pick = all.filter((i) => mock(i) && d(i, 'ccFormat') === fmt && d(i, 'ccSize') === size);
    if (!pick.length) pick = all.filter((i) => mock(i) && d(i, 'ccFormat') === fmt);  // 8-image set: one size per format
    if (!pick.length) return all;                                                      // no mock-ups at all
    const pool = size === '61x91' ? all.filter((i) => d(i, 'kind') === 'own' && d(i, 'ccFormat') === fmt) : [];
    const guide = all.filter((i) => d(i, 'kind') === 'guide');
    const plain = all.filter((i) => d(i, 'kind') === 'plain');
    /* 2026-10-08, v5. The frame-on-a-plain-ground shot for the chosen colour
       leads, and all three rooms follow whatever is chosen.

       Under v4 each colour had four rooms of its own, so filtering rooms by
       the selected format still left a full gallery. v5 has exactly one room
       per colour, so the same filter returned a single room and the page
       showed four images against a ten-image preview.

       Showing all three rooms regardless of the swatch is also what the
       mock-up repo specified for the styled set: every room is captioned
       with the colour it is wearing, so nothing misrepresents anything, and
       a visitor sees the print in three real rooms rather than one. The
       swatch still does visible work - it swaps the lead frame shot and the
       size guide. */
    /* 2026-10-08, the order was specified exactly: "first image frame then
       room then frame alternate colors frame by itself and then the room
       with the matching color frame then the sizes room at the end".

       So the gallery pairs each colour with its own room - the frame on its
       plain ground, then that same colour hanging in a room - and walks the
       colours in turn, with the size guides last. The colour the visitor has
       chosen leads, so the swatch still decides what opens.

       Unframed has a frame shot and no room, by Charly's decision, so it
       contributes a single image and nothing is left dangling. */
    const frames = all.filter((i) => d(i, 'kind') === 'frame');
    if (frames.length) {
      const order = [fmt].concat(
        ['Framed black', 'Framed white', 'Framed natural', 'Unframed'].filter((f) => f !== fmt)
      );
      const seq = [];
      order.forEach((f) => {
        const fr = frames.find((i) => d(i, 'ccFormat') === f);
        if (fr !== undefined) seq.push(fr);
        const rm = all.find((i) => mock(i) && d(i, 'ccFormat') === f);
        if (rm !== undefined) seq.push(rm);
      });
      /* any room whose colour has no frame shot still belongs in the gallery */
      all.filter(mock).forEach((i) => { if (seq.indexOf(i) === -1) seq.push(i); });
      return seq.concat(pool, guide, plain);
    }
    return pick.concat(pool, guide, plain);
  };

  const buildRail = () => {
    if (!rail) return;
    rail.innerHTML = '';
    thumbs = [];
    if (setIdx.length < 2) { rail.hidden = true; return; }
    rail.hidden = false;
    setIdx.forEach((gi, k) => {
      const src = imgs[gi];
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cc-pdp2__thumb';
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', `Show image ${k + 1} of ${setIdx.length}`);
      b.dataset.gi = gi;
      const im = document.createElement('img');
      im.src = src.dataset.thumb || src.currentSrc || src.src;
      im.alt = '';
      im.decoding = 'async';
      b.appendChild(im);
      b.addEventListener('click', () => show(gi));
      rail.appendChild(b);
      thumbs.push(b);
    });
  };

  /* recompute the set; rebuild the rail and mark the viewer stale only if it changed */
  const refreshSet = () => {
    const next = computeSet();
    const key = next.join(',');
    if (key === setKey) return;
    setKey = key;
    setIdx = next;
    buildRail();
    lbDirty = true;
  };

  const fillCaption = (el, im) => {
    if (!el || !im) return;
    const a = el.querySelector('[data-cap-a]'), b = el.querySelector('[data-cap-b]'), pr = el.querySelector('[data-cap-price]');
    if (a) a.textContent = im.dataset.capA || '';
    if (b) b.textContent = im.dataset.capB || '';
    if (pr) pr.textContent = im.dataset.capPrice || '';
    el.hidden = !(im.dataset.capA || im.dataset.capB);
  };

  /* keep the active thumbnail in view by scrolling the rail only - never
     scrollIntoView, which would also move the page */
  const revealThumb = () => {
    const t = thumbs.find((b) => Number(b.dataset.gi) === current);
    if (!t || !rail) return;
    const left = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
  };

  /* 2026-10-04. Give an image its URLs the moment it is wanted.

     The stage renders only the visible image with a real src; the rest hold
     theirs in data-src / data-srcset. Without this they were all fetched on
     load, because stacked absolute images all count as in the viewport and
     loading="lazy" cannot help. Measured: 21 requests and 1.9 MB to show one
     picture.

     Neighbours are hydrated too, so a swipe or an arrow never waits. Hydrating
     is idempotent and the attributes are removed, so this costs nothing after
     the first call. */
  const hydrate = (i) => {
    const im = imgs[i];
    if (!im || !im.dataset.src) return;
    im.srcset = im.dataset.srcset || '';
    im.src = im.dataset.src;
    delete im.dataset.src;
    delete im.dataset.srcset;
  };
  const hydrateAround = (i) => {
    hydrate(i);
    const at = setIdx.indexOf(i);
    if (at === -1) { hydrate(i + 1); hydrate(i - 1); return; }
    hydrate(setIdx[(at + 1) % setIdx.length]);
    hydrate(setIdx[(at - 1 + setIdx.length) % setIdx.length]);
  };

  function show(i) {
    if (!imgs[i]) return;
    current = i;
    hydrateAround(i);
    if (imgs[i].loading === 'lazy') imgs[i].loading = 'eager';
    imgs.forEach((im, k) => im.classList.toggle('is-on', k === i));
    thumbs.forEach((t) => t.setAttribute('aria-current', Number(t.dataset.gi) === i ? 'true' : 'false'));
    fillCaption(cap, imgs[i]);
    revealThumb();
  }

  /* a new choice: lead with that colour's frame shot */
  const showForVariant = (v) => {
    refreshSet();
    const fmt = selFormat();
    const key = `,${v.id},`;

    /* 2026-10-08. This used to pick only from kind 'variant-or-room' and
       prefer the room already on screen, which was right under v4: each
       colour had four rooms of its own, so "the same room in the newly
       chosen colour" was a real image and the stage moved to it.

       v5 has one room per colour and all three show whatever is selected,
       so "the room already on screen" is still in the set after the change
       and the stage simply never moved. Picking White left a natural room
       up, and after a few clicks it sat frozen on one image.

       The frame shot is the honest lead now: it is the only image that IS
       the chosen colour and nothing else. Rooms stay below it, each
       captioned with the colour it wears. The old room-matching is kept as
       the fallback for any product that has no frame shot in that colour,
       which is what a part-uploaded catalogue looks like. */
    const frame = setIdx.find((i) => d(i, 'kind') === 'frame' && d(i, 'ccFormat') === fmt);
    if (frame !== undefined) { show(frame); return; }

    const room = d(current, 'ccRoom');
    const inSet = setIdx.filter((i) => d(i, 'kind') === 'variant-or-room');
    const pick =
      inSet.find((i) => d(i, 'ccRoom') === room) ??
      inSet.find((i) => d(i, 'ccVariants').indexOf(key) !== -1) ??
      inSet[0] ?? setIdx[0];
    if (pick !== undefined) show(pick);
  };

  /* ---- full-screen viewer ----
     Native <dialog> + CSS scroll-snap: swipe on a phone, arrows and keys on
     a desktop, a row of thumbnails underneath, the same caption under every
     photograph, looping at both ends. Shows the current set, rebuilt only
     when the set has changed. Closing leaves the page on the last
     photograph looked at. */
  const lb = document.querySelector('[data-cc-lb]');
  let lbSlides = [], lbThumbs = [], lbIndex = 0, lbObserver = null, lbSettle = null, lbTimer = null;
  let lbViaKeyboard = false;
  const lbTrack = lb && lb.querySelector('[data-cc-lb-track]');
  const lbRail = lb && lb.querySelector('[data-cc-lb-rail]');

  const lbMark = (k) => {
    lbIndex = k;
    lbThumbs.forEach((t, j) => t.setAttribute('aria-current', j === k ? 'true' : 'false'));
    const t = lbThumbs[k];
    if (t && lbRail) lbRail.scrollTo({ left: Math.max(0, t.offsetLeft - (lbRail.clientWidth - t.offsetWidth) / 2), behavior: reduce ? 'auto' : 'smooth' });
  };
  const lbGo = (k, instant) => {
    const sl = lbSlides[k];
    if (!sl) return;
    lbTrack.scrollTo({ left: sl.offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
    lbMark(k);
  };
  const lbStep = (dir) => {
    const all = lbTrack.children, w = lbTrack.clientWidth;
    if (all.length < 2 || !w) return;
    const target = Math.max(0, Math.min(all.length - 1, Math.round(lbTrack.scrollLeft / w) + dir));
    lbTrack.scrollTo({ left: all[target].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    if (reduce && lbSettle) lbSettle();
  };
  const makeSlide = (src) => {
    const fig = document.createElement('figure');
    fig.className = 'cc-lb__slide';
    const im = document.createElement('img');
    im.src = src.dataset.full || src.currentSrc || src.src;
    im.alt = src.alt || '';
    im.decoding = 'async';
    im.loading = 'lazy';
    fig.appendChild(im);
    if (src.dataset.capA || src.dataset.capB) {
      const fc = document.createElement('figcaption');
      fc.className = 'cc-lb__cap';
      fc.innerHTML = '<span class="cc-lb__cap-txt"><span></span><span></span></span><b></b>';
      fc.querySelector('.cc-lb__cap-txt span:first-child').textContent = src.dataset.capA || '';
      fc.querySelector('.cc-lb__cap-txt span:last-child').textContent = src.dataset.capB || '';
      fc.querySelector('b').textContent = src.dataset.capPrice || '';
      fig.appendChild(fc);
    }
    return fig;
  };
  const lbBuild = () => {
    if (!lb || !lbDirty) return;
    lbDirty = false;
    if (lbObserver) lbObserver.disconnect();
    lbTrack.innerHTML = '';
    if (lbRail) lbRail.innerHTML = '';
    lbSlides = []; lbThumbs = []; lbSettle = null;
    setIdx.forEach((gi, k) => {
      const src = imgs[gi];
      const fig = makeSlide(src);
      lbTrack.appendChild(fig);
      lbSlides.push(fig);
      if (lbRail && setIdx.length > 1) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-lb__thumb';
        b.setAttribute('aria-label', `Image ${k + 1} of ${setIdx.length}`);
        const ti = document.createElement('img');
        ti.src = src.dataset.thumb || src.src;
        ti.alt = '';
        b.appendChild(ti);
        b.addEventListener('click', () => lbGo(k));
        lbRail.appendChild(b);
        lbThumbs.push(b);
      }
    });
    lb.classList.toggle('cc-lb--single', setIdx.length < 2);
    /* loop: copies of the last and first slides at either end; resting on
       one jumps instantly to the real slide it copies */
    if (lbSlides.length > 1) {
      const head = lbSlides[lbSlides.length - 1].cloneNode(true);
      const tail = lbSlides[0].cloneNode(true);
      [head, tail].forEach((c) => { c.classList.add('cc-lb__slide--clone'); c.setAttribute('aria-hidden', 'true'); c.querySelector('img').loading = 'eager'; });
      lbTrack.insertBefore(head, lbTrack.firstChild);
      lbTrack.appendChild(tail);
      lbSettle = () => {
        const all = lbTrack.children, w = lbTrack.clientWidth;
        if (!w) return;
        const pos = Math.round(lbTrack.scrollLeft / w);
        if (pos <= 0) lbGo(lbSlides.length - 1, true);
        else if (pos >= all.length - 1) lbGo(0, true);
      };
    }
    lbObserver = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.intersectionRatio >= 0.6) lbMark(lbSlides.indexOf(e.target)); });
    }, { root: lbTrack, threshold: [0.6] });
    lbSlides.forEach((sl) => lbObserver.observe(sl));
  };
  if (lbTrack) {
    lbTrack.addEventListener('scroll', () => { clearTimeout(lbTimer); lbTimer = setTimeout(() => lbSettle && lbSettle(), 140); }, { passive: true });
    if ('onscrollend' in window) lbTrack.addEventListener('scrollend', () => lbSettle && lbSettle());
  }
  const lbOpen = (gi) => {
    if (!lb) return;
    lbBuild();
    const k = Math.max(0, setIdx.indexOf(gi));
    [k - 1, k, k + 1].forEach((j) => { const sl = lbSlides[j]; if (sl) sl.querySelector('img').loading = 'eager'; });
    document.documentElement.classList.add('cc-lb-open');
    if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
    lbGo(k, true);                                   // layout exists as soon as the dialog is open
    requestAnimationFrame(() => lbGo(k, true));      // and again once painted, for Safari
  };
  /* closing is synced directly as well as on the dialog's own 'close'
     event (which Escape fires), so the page never depends on that event
     arriving - and running it twice is harmless */
  const lbAfterClose = () => {
    document.documentElement.classList.remove('cc-lb-open');
    if (setIdx[lbIndex] !== undefined) show(setIdx[lbIndex]);
    /* back to the picture only for keyboard users - a mouse or touch close
       would otherwise leave a focus ring drawn round it */
    if (stage && lbViaKeyboard) stage.focus({ preventScroll: true });
  };
  const lbClose = () => {
    if (lb.open) { if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open'); }
    lbAfterClose();
  };
  if (lb) {
    lb.querySelector('[data-cc-lb-close]').addEventListener('click', lbClose);
    lb.querySelector('[data-cc-lb-prev]').addEventListener('click', () => lbStep(-1));
    lb.querySelector('[data-cc-lb-next]').addEventListener('click', () => lbStep(1));
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbStep(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbStep(-1); }
    });
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target === lbTrack) lbClose(); });
    lb.addEventListener('close', lbAfterClose);
  }

  /* the main picture swipes left / right through the set, looping, so the
     plain photograph (always last) is one swipe back from the first image.
     Pointer events on the stage only, passive, with touch-action: pan-y in
     the CSS - vertical page scrolling stays native and nothing is
     registered on window. */
  let swipeX = null, swipeY = null, swiped = false;
  if (stage) {
    stage.addEventListener('pointerdown', (e) => { swipeX = e.clientX; swipeY = e.clientY; swiped = false; }, { passive: true });
    stage.addEventListener('pointerup', (e) => {
      if (swipeX === null) return;
      const dx = e.clientX - swipeX, dy = e.clientY - swipeY;
      swipeX = null;
      if (setIdx.length > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        swiped = true;
        const n = setIdx.length, k = Math.max(0, setIdx.indexOf(current));
        show(setIdx[dx < 0 ? (k + 1) % n : (k - 1 + n) % n]);
      }
    }, { passive: true });
    stage.addEventListener('pointercancel', () => { swipeX = null; }, { passive: true });
    stage.addEventListener('click', (e) => { if (swiped) { swiped = false; return; } lbViaKeyboard = e.detail === 0; lbOpen(current); });
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbViaKeyboard = true; lbOpen(current); }
    });
  }

  /* ---- selection ---- */
  const fmtGroup = groupByName('Format');
  const sizeGroup = groupByName('Size');

  const relabelSizes = () => {
    if (!fmtGroup || !sizeGroup) return;
    const fmt = checked(fmtGroup) && checked(fmtGroup).dataset.ccValue;
    const fi = Number(fmtGroup.dataset.ccGroup), si = Number(sizeGroup.dataset.ccGroup);
    sizeGroup.querySelectorAll('[data-cc-value]').forEach((b) => {
      const v = variants.find((x) => optsOf(x)[fi] === fmt && optsOf(x)[si] === b.dataset.ccValue);
      const slot = b.querySelector('[data-cc-size-price]');
      if (slot) slot.textContent = v ? priceOf(v) : '';
    });
  };

  const render = (fromFormat) => {
    groups.forEach((g) => {
      const b = checked(g), legend = g.querySelector('[data-cc-legend]');
      if (b && legend) legend.textContent = b.dataset.ccLabel;
    });
    const v = findVariant(selection());
    if (!v) {
      atc.disabled = true;
      atc.textContent = 'Unavailable';
      return;
    }
    idEl.value = v.id;
    if (priceEl) priceEl.textContent = priceOf(v);
    if (priceNote) {
      const f = checked(fmtGroup), s = checked(sizeGroup);
      priceNote.textContent = [f && f.dataset.ccLabel, s && s.dataset.ccLabel].filter(Boolean).join(' · ');
    }
    atc.disabled = !v.available;
    atc.textContent = v.available ? 'Add to cart' : 'Sold out';
    showForVariant(v);
    updateOverview(v);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(null, '', url);
    } catch (_) { /* not essential */ }
  };

  const select = (btn) => {
    const g = btn.closest('[data-cc-group]');
    if (!g || btn.getAttribute('aria-checked') === 'true') return;
    g.querySelectorAll('[data-cc-value]').forEach((b) => b.setAttribute('aria-checked', b === btn ? 'true' : 'false'));
    const isFormat = g === fmtGroup;
    if (isFormat) relabelSizes();
    render(isFormat);
  };

  groups.forEach((g) => {
    const btns = Array.from(g.querySelectorAll('[data-cc-value]'));
    btns.forEach((b, i) => {
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
      b.addEventListener('click', () => {
        select(b);
        btns.forEach((x) => { x.tabIndex = x === b ? 0 : -1; });
      });
      /* radiogroup keyboard pattern: arrows move and select */
      b.addEventListener('keydown', (e) => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        const n = btns[(i + d + btns.length) % btns.length];
        n.focus();
        n.click();
      });
    });
  });

  /* On load: set, rail, caption, stage and the overview panel all agree with
     the server-rendered choice. The panel needs this explicitly - it is filled
     by JS, so without it the visitor's first sight of it is a column of dashes. */
  {
    const v0 = findVariant(selection());
    if (v0) updateOverview(v0);
  }
  refreshSet();
  if (!setIdx.includes(current)) current = setIdx[0];
  show(current);

  /* ---- gift ---- */
  const giftToggle = root.querySelector('[data-cc-gift-toggle]');
  const giftFields = root.querySelector('[data-cc-gift-fields]');
  const giftMessage = root.querySelector('[data-cc-gift-message]');
  const giftFlag = root.querySelector('[data-cc-gift-flag]');
  if (giftToggle && giftFields && giftMessage && giftFlag) {
    giftToggle.addEventListener('change', () => {
      const on = giftToggle.checked;
      giftFields.hidden = !on;
      giftMessage.disabled = !on;
      giftFlag.disabled = !on;
      giftFlag.value = on ? 'Yes' : '';
      if (on) giftMessage.focus();
    });
  }

  /* ---- add to cart confirmation (unchanged motion: checkmark, 1.5 s) ---- */
  if (form && atc) {
    form.addEventListener('submit', () => {
      try { localStorage.setItem('cc:cart-just-added', String(Date.now())); } catch (_) {}
      const original = atc.textContent;
      atc.classList.add('cc-atc-confirming');
      atc.textContent = '✓';
      atc.disabled = true;
      setTimeout(() => {
        atc.classList.remove('cc-atc-confirming');
        atc.textContent = original;
        atc.disabled = false;
      }, 1500);
    });
  }

  /* ---- the print, close up: loupe (2026-09-28) ----
     Fine pointer: a round lens follows the pointer and shows the photograph
     at 3x from the large file, loaded on first hover. Touch: a tap zooms the
     picture 2.5x in place, centred on the tap; the zoomed picture pans by the
     box's own native scroll; a second tap zooms out. Listeners are on the
     box only, all passive - nothing here touches page scrolling. */
  document.querySelectorAll('[data-cc-loupe]').forEach((box) => {
    const img = box.querySelector('img');
    const lens = box.querySelector('.cc-story__lens');
    if (!img || !lens) return;
    /* as close as the file allows: 2x to 3x, never past the file's own pixels by much */
    const zoomFor = (w) => Math.max(2, Math.min(3, (parseFloat(box.dataset.fullW) || 2400) / w));
    let loaded = false;
    const load = () => {
      if (loaded) return;
      loaded = true;
      lens.style.backgroundImage = 'url("' + (box.dataset.full || img.currentSrc || img.src) + '")';
    };
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const move = (e) => {
      const r = box.getBoundingClientRect();
      const x = e.clientX - r.left, y = e.clientY - r.top, ZOOM = zoomFor(r.width);
      if (x < 0 || y < 0 || x > r.width || y > r.height) return;
      const lw = lens.offsetWidth / 2, lh = lens.offsetHeight / 2;
      lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
      lens.style.backgroundPosition = (lw - x * ZOOM) + 'px ' + (lh - y * ZOOM) + 'px';
      lens.style.translate = x + 'px ' + y + 'px';
    };
    box.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      load(); box.classList.add('is-looking'); move(e);
    }, { passive: true });
    box.addEventListener('pointermove', (e) => { if (box.classList.contains('is-looking')) move(e); }, { passive: true });
    box.addEventListener('pointerleave', () => box.classList.remove('is-looking'), { passive: true });

    /* touch and pen: tap to zoom in place */
    box.addEventListener('click', (e) => {
      if (fine.matches) return;
      const r = box.getBoundingClientRect();
      if (box.classList.contains('is-zoomed')) {
        box.classList.remove('is-zoomed');
        box.scrollTo(0, 0);
        return;
      }
      const fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      if (box.dataset.full && img.src !== box.dataset.full) { img.removeAttribute('srcset'); img.src = box.dataset.full; }
      box.classList.add('is-zoomed');
      box.scrollTo(fx * box.scrollWidth - r.width / 2, fy * box.scrollHeight - r.height / 2);
    });
  });
})();
